import { IContactInformation } from "redux/contactInformation";
import { ITraveler } from "redux/travelerInformation";

export const contactInformationDummy: IContactInformation = {
  genderType: "male",
  firstName: "Axel",
  middleName: "",
  lastName: "Foley",
  phoneNumber: {
    countryCode: 46,
    country: "SE",
    national: "077-179 33 36",
    international: "+46 77 179 33 36",
  },
  email: "axel.foley@awesome.net",
};

export const travelerAdultDummy: ITraveler = {
  formFields: {
    genderType: "male",
    firstName: "Axel",
    middleName: "",
    lastName: "Foley",
    dateOfBirth:
      "Wed Aug 11 1993 00:00:00 GMT+0200 (Central European Summer Time)",
    mealRequest: "",
  },
  passengerType: "ADT",
};

export const travelerChildDummy: ITraveler = {
  formFields: {
    genderType: "male",
    firstName: "Frank",
    middleName: "",
    lastName: "Drebin",
    dateOfBirth:
      "Wed Aug 09 2020 00:00:00 GMT+0200 (Central European Summer Time)",
    mealRequest: "",
  },
  passengerType: "CNN",
};

export const travelerInfantDummy: ITraveler = {
  formFields: {
    genderType: "female",
    firstName: "George",
    middleName: "",
    lastName: "Costanza",
    dateOfBirth:
      "Thu Aug 10 2023 00:00:00 GMT+0200 (Central European Summer Time)",
    mealRequest: "",
  },
  passengerType: "INF",
};

export const travelerYouthDummy: ITraveler = {
  formFields: {
    genderType: "female",
    firstName: "Niles",
    middleName: "",
    lastName: "Crane",
    dateOfBirth:
      "Thu Aug 12 2010 00:00:00 GMT+0200 (Central European Summer Time)",
    mealRequest: "",
  },
  passengerType: "YTH",
};

export const travelerStudentDummy: ITraveler = {
  formFields: {
    hasStudentCard: "no",
    discountCardNumber: "",
    cardExpiryDate: "",
    isFullTimeStudent: "yes",
    nameOfSchool: "Kilroy school of destiny",
    email: "ace.ventura@optur.com",
    genderType: "female",
    firstName: "Ace",
    middleName: "",
    lastName: "Ventura",
    dateOfBirth:
      "Thu Aug 16 2001 00:00:00 GMT+0200 (Central European Summer Time)",
    mealRequest: "",
  },
  passengerType: "STU",
};

export const sameAsContactPersonDummy = true;

export const checkoutStepsDummy = {
  shouldRevalidate: true,
  currentStep: 0,
  allStepsAreValid: false,
  steps: {
    brandedFares: {
      valid: true,
      expanded: true,
      disabled: false,
    },
    contactInformation: {
      valid: true,
      expanded: true,
      disabled: false,
    },
    travelerInformation: {
      valid: true,
      expanded: true,
      disabled: false,
    },
    additionalProducts: {
      valid: true,
      expanded: true,
      disabled: false,
    },
    paymentMethod: {
      valid: false,
      expanded: true,
      disabled: false,
    },
  },
};
